export default __webpack_public_path__ + "62daaadff3957c05374f0ae21181025d.svg";